<template>
  <b-card>
    <div class="d-flex table-header-border-bottom pb-1 mb-3">
      <div class="d-flex flex-column justify-content-center">
        <feather-icon size="18" icon="UsersIcon" class="mr-50" />
      </div>

      <h3 class="my-1">Top participants</h3>
    </div>
    <data-table
      class="mt-1"
      :fields="fields"
      :items="participants"
      :loading="loading"
    >
      <template #participants="{ data }">
        <div class="d-flex align-items-center">
          <b-skeleton width="40px" height="40px" v-if="loading" />

          <b-avatar
            v-else
            size="50"
            variant="light-primary"
            rounded="avatar"
            style="border: 2px solid #73747e !important"
            :src="data.item.user.data.avatar"
          />

          <div class="d-flex flex-column ml-1">
            <div v-if="loading">
              <b-skeleton width="50px" height="15px" />
              <b-skeleton width="80px" height="15px" />
            </div>
            <div v-else>
              <span
                >{{ data.item.user.data.first_name }}
                {{ data.item.user.data.last_name }}</span
              ><br />
              <span class="text-muted">{{ data.item.user.data.email }}</span>
            </div>
          </div>
        </div>
      </template>

      <template #added_at="{ data }">
        <b-skeleton width="50px" height="15px" v-if="loading" />
        <div v-else>
          {{ data.item.added_at ? " $ " + data.item.added_at : "-" }}
        </div>
      </template>
      <template #rank="{ data }">
        <b-skeleton width="50px" height="15px" v-if="loading" />

        <span v-else class="text-muted">
          {{ data.item.user.data.rank || "-" }}
        </span>
      </template>
      <template #balance="{ data }">
        <b-skeleton width="50px" height="15px" v-if="loading" />
        <span v-else-if="data.item.user.data.balance">
          $ {{ data.item.user.data.balance }}
        </span>
        <b-badge variant="light-success" v-else>Paid</b-badge>
      </template>
      <template #actions>
        <feather-icon icon="EyeIcon" class="mx-1 cursor-pointer" />
      </template>
    </data-table>

    <div
      class="w-100 d-flex flex-wrap align-items-center justify-content-between"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        size="lg"
        pills
        class="my-2 d-flex justify-content-center"
      >
      </b-pagination>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  BAvatar,
  BRow,
  BSkeleton,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    BAvatar,
    BRow,
    BSkeleton,
  },
  // props: {
  //   loading: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  data() {
    return {
      url: "/panel/participants",
      loading: false,
      currentPage: 1,
      pagination: {},
      fields: [
        { key: "participants", label: "participants" },
        { key: "added_at", label: "added at" },
        { key: "rank", label: "rank" },
        { key: "balance", label: "balance" },
        { key: "actions", label: "actions" },
      ],
      participants: [],
    };
  },
  directives: {
    "b-modal": VBModal,
  },
  async created() {
    // await this.getParticipants();
  },
  watch: {
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "participants",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      handler(val) {
        this.getParticipants();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    async getParticipants() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get("panel/dashboard/participants", {
          params,
        });
        this.participants = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
